<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="55rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.updateProfile')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <v-divider class="mb-4"></v-divider>
        <!--content-->
        <v-card-text>
          <div class="form-group row-ty">
            <div class="form-row">
              <div class="txt-tit">
                {{t('message.id')}} / {{t('message.department')}} / {{t('message.position')}}
              </div>
              <div class="row">
                <c-Input v-bind="info" v-model="infoVal" :name="'info'" />
              </div>
            </div>
            <div class="form-row">
              <div class="txt-tit">
                {{t('message.currentPassword')}}
              </div>
              <div class="row">
                <c-Input v-bind="oldPw" v-model="password" :name="'password'" :disabled="userInfo.passwordYn != 'Y'"/>
              </div>
            </div>
            <div class="form-row">
              <div class="txt-tit">
                {{t('message.newPassword')}}
              </div>
              <div class="row">
                <c-Input v-bind="newPw" v-model="passwordNew" :name="'passwordNew'"  :disabled="userInfo.passwordYn != 'Y'"/>
              </div>
            </div>
            <div class="form-row">
              <div class="txt-tit">
                {{t('message.confirmNewPassword')}}
              </div>
              <div class="row">
                <c-Input v-bind="newPwReenter" v-model="passwordNewRe" :name="'passwordNewRe'"  :disabled="userInfo.passwordYn != 'Y'"/>
              </div>
            </div>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end">
          <!-- <c-btn02 v-bind="btnDel"/> -->
          <c-btn01 v-bind="btnSave" @click="onClickSave" :disabled="userInfo.passwordYn != 'Y'"/>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import * as yup from "yup";
import {useForm} from "vee-validate";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import {useRoute} from "vue-router";
import utils from "@/common/Utils";
import MemberService from "@/services/member.service";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//validation schema
const schema = yup.object().shape({
  password: yup.string().required(() => t('message.requiredField')),
  passwordNew: yup.string().required(() => t('message.requiredField')),
  passwordNewRe: yup
    .string()
    .oneOf([yup.ref("passwordNew")], "비밀번호가 일치하지 않습니다.")
    .required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const infoVal = ref('')
const password = ref('')
const passwordNew = ref('')
const passwordNewRe = ref('')
const userInfo:any = ref({})
const snackbar = ref(false)
const snackText = ref('')

//ui
const info = {
  type: 'text',
  value:'fidelity / 경영지원부 / 과장',
  disabled:true
}
const oldPw = computed(() => ({
  type: 'password',
  placeholder: t('message.currentPassword')+t('message.enterValue'),
}))
const newPw = computed(() => ({
  type: 'password',
  placeholder: t('message.newPassword')+t('message.enterValue'),
}))
const newPwReenter = computed(() => ({
  type: 'password',
  placeholder: t('message.confirmNewPassword')+t('message.enterValue'),
}))
const btnDel = {
  btnText: t('message.delete'),
}
const btnSave = {
  btnText: t('message.save'),
}

//hook
onUpdated(() => {
  if(dialog.value)
    getMember()
})

//function
const getMember = async ()=>{
  try {
    const user = JSON.parse(localStorage.getItem('user'))
    infoVal.value = (user.memberId?user.memberId:t('message.noInfo')) + ' / ' + (user.deptName?user.deptName:t('message.noInfo')) + ' / ' + (user.posName?user.posName:t('message.noInfo'))
    const response = await MemberService.getMemberDto({idx:user.memberIdx})
    if(response.success)
      userInfo.value = response.result
    else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch (error) {
    if(error.status == 403)
      utils.movePage('/login')
    else
      utils.log(error)
  }
}

const onClickSave = async ()=>{
  if(userInfo.value.passwordYn != 'Y')
    return

  try {
    const result = await validate()
    if(!result.valid)
      return

    userInfo.value.password = password.value
    userInfo.value.passwordNew = passwordNew.value
    const response = await MemberService.insertMember(JSON.parse(JSON.stringify(userInfo.value)))
    if(response.success)
      dialog.value=false
    else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch (error) {
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}
</script>


<style lang="scss">
</style>
